import React, { useState } from "react";
import "./App.css";
import emailjs from "emailjs-com";

export default function App() {

const [message, setMessage] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      "service_a93sbva",
      "template_snmspv7",
      e.target,
      "TpD2aGx23p2UhG0ie"
    ).then(() => {
      setMessage("Message sent successfully!");
    }).catch(() => {
      setMessage("Failed to send message.");
    });
  };

  return (
    <div className="app">
      {/* Header */}
      <header className="header">
<div className="container header-content">
              <a className="navbar-brand" href="/">
              <img width="350" height="120" src={require("./images/logo.png")} alt="Logo" />
            </a>
    <nav>
            <a href="#aboutus">About Us</a>
            <a href="#services">Services</a>
            <a href="#products">Products</a>
            <a href="#technology">Technology</a>
            <a href="#whyus">Why Us</a>
            <a href="#contact">Contact</a>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="hero">
        <div className="container">
          <h2>Empowering Businesses Through Innovative Software</h2>
          <p>From process analysis to deployed solutions — we turn your ideas into reality, faster and smarter.</p>
  {/*        <button className="cta-btn">Get a Free Consultation</button> */}
         <img
            src="https://images.unsplash.com/photo-1556761175-4b46a572b786?auto=format&fit=crop&w=1200&q=80"
            alt="Business Optimization"
          />
        </div>
      </section>

      {/* About Us */}
      <section id="aboutus" className="section">
        <div className="container">
          <h3>About Us</h3>
          <p>
            SparkEdge Solutions is a forward-thinking software development firm specializing in tailored solutions
            that streamline operations and accelerate growth. We partner with businesses to analyze their processes,
            identify inefficiencies, and create innovative products that deliver measurable results.
          </p>
     {/*}     <img
            src="https://images.unsplash.com/photo-1521790361557-9a9a0e1c3a06?auto=format&fit=crop&w=1200&q=80"
            alt="Software Development"
          /> */}
        </div>
      </section>

      {/* Services */}
      <section id="services" className="section bg-light">
        <div className="container">
          <h3>Our Services</h3>
          <div className="grid">
            <div className="card">
              <img
                src="https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=800&q=80"
                alt="Process Analysis"
              />
              <h4>Business Process Analysis</h4>
              <p>Identify bottlenecks and implement software-driven improvements to save time and cut costs.</p>
            </div>
            <div className="card">
              <img
                src="https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=800&q=80"
                alt="Custom Software"
              />
              <h4>Custom Software Development</h4>
              <p>Secure, scalable, and tailored software to give your business a competitive edge.</p>
            </div>
            <div className="card">
              <img
                src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=800&q=80"
                alt="SaaS Development"
              />
              <h4>SaaS Product Development</h4>
              <p>Robust SaaS solutions that deliver seamless experiences and long-term value.</p>
            </div>
            <div className="card">
              <img
                src="https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?auto=format&fit=crop&w=800&q=80"
                alt="Data Analytics"
              />
              <h4>Data Analytics</h4>
              <p>Turn raw data into actionable insights to improve decision-making and growth.</p>
            </div>
          </div>
          <button 
  className="cta-btn" 
  onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })}
>
  Request a Quote
</button>
        </div>
      </section>

      {/* Products */}
      <section id="products" className="section">
        <div className="container">
          <h3>Our Products</h3>
          <p>
            Our flagship product, <strong>TradeBarta.com</strong>, is a SaaS web platform for stock market investors to 
            receive notifications to help them make timely investment decisions.
          <button 
            className="cta-btn" 
            style={{ marginTop: "10px" }}
          >
            Will Launch Soon
          </button>

          </p>
<div style = {{display: "flex", justifyContent: "center"}}>
    {/*      <img width ='600px' height = '600px' 
            src="https://api.tradebarta.com/static/media/about-image.25fc85a11c2731012e99.jpg"
            alt="Stock Alert Platform"
          />
          */}
          </div>
        </div>
      </section>

      {/* Technology */}
      <section id="technology" className="section bg-light">
        <div className="container">
          <h3>Technology We Use</h3>
          <ul className="tech-list">
            <li>React</li>
            <li>Node.js</li>
            <li>.NET</li>
            <li>MySQL</li>
            <li>SQL Server</li>
            <li>PostgreSQL</li>
          </ul>
        </div>
      </section>

      {/* Why Us */}
      <section id="whyus" className="section">
        <div className="container">
          <h3>Why Choose Us?</h3>
          <ul className="why-list">
            <li>Highly Qualified Professionals with years of experience</li>
            <li>Proven track record in business process optimization</li>
            <li>Modern tech stack expertise</li>
            <li>Client-focused, transparent communication</li>
            <li>Innovative solutions for long-term value</li>
          </ul>
       {/*   <button className="cta-btn">Book a Strategy Call</button>  */}
           </div>
      </section>

      {/* Contact */}
      <section id="contact" className="section bg-dark">
        <div className="container">
          <h3>Contact Us</h3>
          <p>Let's build something great together. Reach out today.</p>
<form className="contact-form" onSubmit={handleSubmit}>
      <input type="text" name="name" placeholder="Your Name" />
      <input type="email" name="email" placeholder="Your Email" />
      <textarea name="message" placeholder="Your Message" rows="5"></textarea>
      <button type="submit" className="cta-btn">Send Message</button>
    </form> 
      {message && (
            <p style={{ textAlign: "center", color: message.includes('success') ? 'green' : 'red' }}>
              {message}
            </p>)}

          <p style={{fontSize: '18px'}}>Email: contact@sparkedgesolutions.com</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} SparkEdge Solutions. All rights reserved.</p>
      </footer>
    </div>
  );
}
